import { ContentInstructions, CoreContents, FromSettingsInstruction, UiAction } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type HeatmapOptions = {
  data?: DataOptionsFactory;
  xGrouping: string | FromSettingsInstruction;
  yGrouping: string | FromSettingsInstruction;
  sortX?: boolean;
  sortY?: boolean;
  kpi: string | FromSettingsInstruction;
  clickAction?: UiAction;
};

export class HeatmapFactory extends ContentFactory {
  constructor(options: HeatmapOptions) {
    const { data, xGrouping, yGrouping, kpi, sortX, sortY, clickAction } = options;

    const instructions: ContentInstructions = {
      xGrouping:
        typeof xGrouping === 'string'
          ? {
              type: 'StringInstruction',
              instruction: xGrouping,
            }
          : xGrouping,
      yGrouping:
        typeof yGrouping === 'string'
          ? {
              type: 'StringInstruction',
              instruction: yGrouping,
            }
          : yGrouping,
      kpi:
        typeof kpi === 'string'
          ? {
              type: 'StringInstruction',
              instruction: kpi,
            }
          : kpi,
    };

    if (sortX) {
      instructions.sortX = {
        type: 'BooleanInstruction',
        instruction: sortX,
      };
    }

    if (sortY) {
      instructions.sortY = {
        type: 'BooleanInstruction',
        instruction: sortY,
      };
    }

    if (clickAction) {
      instructions.clickAction = {
        type: 'ObjectInstruction',
        instruction: clickAction,
      };
    }

    super(CoreContents.heatmap, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
